var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Iconly/Light-Outline/Profile"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Profile"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 3"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 18,
    width: 20,
    height: 10
  }, /*#__PURE__*/React.createElement("path", {
    id: "Clip 2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 18.1201H24.7999V27.3376H5V18.1201Z",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill 1",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9012 19.9951C9.575 19.9951 6.875 20.9101 6.875 22.7164C6.875 24.5389 9.575 25.4626 14.9012 25.4626C20.2262 25.4626 22.925 24.5476 22.925 22.7414C22.925 20.9189 20.2262 19.9951 14.9012 19.9951ZM14.9012 27.3376C12.4525 27.3376 5 27.3376 5 22.7164C5 18.5964 10.6512 18.1201 14.9012 18.1201C17.35 18.1201 24.8 18.1201 24.8 22.7414C24.8 26.8614 19.15 27.3376 14.9012 27.3376Z",
    fill: "currentColor"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group 6"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 2,
    width: 14,
    height: 14
  }, /*#__PURE__*/React.createElement("path", {
    id: "Clip 5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.2627 2.5H21.5377V15.7732H8.2627V2.5Z",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill 4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9014 4.28408C12.2252 4.28408 10.0477 6.46033 10.0477 9.13658C10.0389 11.8041 12.2002 13.9791 14.8652 13.9891L14.9014 14.8816V13.9891C17.5764 13.9891 19.7527 11.8116 19.7527 9.13658C19.7527 6.46033 17.5764 4.28408 14.9014 4.28408ZM14.9015 15.7728H14.8615C11.209 15.7615 8.25023 12.7828 8.26273 9.13277C8.26273 5.47652 11.2402 2.49902 14.9015 2.49902C18.5615 2.49902 21.5377 5.47652 21.5377 9.13652C21.5377 12.7965 18.5615 15.7728 14.9015 15.7728Z",
    fill: "currentColor"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.65b7927037aaf588f1a48e0a27b04756.svg";
export { ForwardRef as ReactComponent };